import { useCallback, useRef } from 'react';

import { useAuth } from '@workos-inc/authkit-react';

import { RoutesEnum } from '@/enums';

export const useLogout = () => {
  const { signOut } = useAuth();
  const inFlightLogout = useRef<Promise<void> | null>(null);

  return useCallback(async () => {
    if (inFlightLogout.current) {
      return inFlightLogout.current;
    }

    const returnTo = `${window.location.origin}${RoutesEnum.LOGIN}?loggedOut=1`;
    const logoutPromise = Promise.resolve(signOut({ returnTo }))
      .catch(error => {
        console.error('Failed to logout', error);
      })
      .finally(() => {
        inFlightLogout.current = null;
      });

    inFlightLogout.current = logoutPromise;
    return logoutPromise;
  }, [signOut]);
};
